import { useStoreQuery } from '@client/queries/useStoreQuery';
import { getEntitlementOperations } from '@client/services/entitlements.service';

import type { IPricingRule } from '@common/types';

export const entitlementsKeys = {
  all: ['entitlements'] as const,
  operations: () => [...entitlementsKeys.all, 'operations'] as const,
};

export const useEntitlementsQueries = () => {
  const useOperations = () =>
    useStoreQuery<IPricingRule[]>({
      queryKey: entitlementsKeys.operations(),
      queryFn: getEntitlementOperations,
    });

  return { useOperations };
};
